import { ImageFormBlock } from 'models/common/form/formContentBlock/ImageFormBlock';

export default class ImageFormBlockService {
	toModel(formBlock) {
		return new ImageFormBlock(formBlock);
	}
}
